import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import RedirectFooter from './RedirectFooter';

const MN_LOGO = `${process.env.PUBLIC_URL}/images/mp-logo.svg`;

function BackArrowIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  );
}

export default function LegalLayout() {
  return (
    <div className="pr-root">
      <header className="pr-topbar">
        <div className="pr-topbar-inner">
          <Link to="/" className="pr-legal-back" aria-label="Back to home">
            <img className="pr-brand-logo" src={MN_LOGO} alt="masterNAUKRI" />
          </Link>
          <Link to="/" className="pr-legal-home-link">
            <BackArrowIcon />
            <span>Back to home</span>
          </Link>
        </div>
      </header>

      <main className="pr-legal-main">
        <Outlet />
      </main>

      <RedirectFooter />
    </div>
  );
}
